import { useNavigate, useParams } from 'react-router-dom';
import { Container } from 'ui';
import { useSnack, useError } from 'hooks';
import { useTranslation } from 'react-i18next';
import { KoobPageHeader, KoobCard } from '@koob/ui';
import SettingRequestForm from 'components/Forms/SettingRequestForm';
import { createSettingRequest } from 'api/node/settingRequests';

// The list each setting request is made from, to link back to it.
const SETTING_LISTS = {
  hotel: {
    category: ['pages:hotelCategories', '/settings/hotels/categories'],
    style: ['pages:hotelStyles', '/settings/hotels/styles'],
    location: ['pages:hotelLocations', '/settings/hotels/locations'],
    accreditations: [
      'pages:hotelAccreditations',
      '/settings/hotels/accreditations',
    ],
    descriptions: [
      'pages:hotelGeneralCategories',
      '/settings/hotels/general-categories',
    ],
    'dmc-category': [
      'pages:hotelDmcCategories',
      '/settings/hotels/dmc-categories',
    ],
    room: ['pages:roomTypes', '/settings/hotels/room-types'],
    bed: ['pages:bedTypes', '/settings/hotels/bed-types'],
    sustainable: [
      'pages:sustainableClusters',
      '/settings/hotels/sustainable-clusters',
    ],
    'meal-plan': ['pages:mealPlans', '/settings/hotels/meal-plans'],
    facility: [
      'facility:navNameFacilities',
      '/settings/hotels/facilities-groups/facilities',
    ],
    group: ['group:navNameGroups', '/settings/hotels/facilities-groups/groups'],
  },
  experience: {
    segment: ['mainSidebar:segments', '/settings/experiences/segments'],
    theme: ['mainSidebar:themes', '/settings/experiences/themes'],
  },
};

const CreateSettingRequest = ({ kind }) => {
  const { t } = useTranslation('settingRequest');
  const navigate = useNavigate();
  const { notify } = useSnack();
  const { sendErrorSnack } = useError();
  const { settingName } = useParams();
  const list = SETTING_LISTS[kind]?.[settingName];

  const handleCreateSettingRequest = async (values) => {
    try {
      const input = {
        ...values,
        settingName,
        kind,
      };

      const data = await createSettingRequest({ payload: input });

      if (data?.errors?.length > 0) {
        throw data?.errors?.[0];
      }

      navigate(-1);
      notify(t('createSettingRequestSuccess'));
    } catch (err) {
      sendErrorSnack(err);
    }
  };

  return (
    <>
      <KoobPageHeader
        title={t('newSettingRequest')}
        breadcrumbs={list ? [{ label: t(list[0]), to: list[1] }] : undefined}
      />
      <Container size="narrow">
        <KoobCard>
          <SettingRequestForm onSubmit={handleCreateSettingRequest} />
        </KoobCard>
      </Container>
    </>
  );
};

export default CreateSettingRequest;
